import { ApiCall } from "components/common/services/ApiServices";
import {
  BASIC_DETAILS,
  GET_PLANNING_RELOCATION_DETAILS,
  REMENUARATION_DETAILS,
  SET_DROPDOWN_DATA,
  UPDATE_FIELDS,
} from "../../annotation/PlanningConstants";
import { COMPANY_MICROSERVICE } from "Constants";
import type { GeneralProps } from "../../annotation/PlanningInterface";
import CustomNotify from "components/common/atoms/CustomNotify";
import { t } from "components/CentralDataMangement/translation/Translation";

export const fetchRelocationDetails = async (
  pcId: number | null | undefined,
  branchId: number | null | undefined,
  empId: any,
  dispatch: React.Dispatch<any>,
  pc?: boolean,
  isEmp?: boolean,
  type?: number,
  planningId?: number | string | undefined,
  addressData?: object,
  generalDetails?: GeneralProps,
  distance?: string | number | null
) => {
  let address = addressData;
  if (addressData) {
    address = addressData;
  } else {
    address = {
      street: generalDetails?.street,
      number: generalDetails?.number,
      city: generalDetails?.city,
      country: generalDetails?.country,
      zipCode: generalDetails?.zipCode,
      box: generalDetails?.box,
      lat: generalDetails?.lat,
      lng: generalDetails?.lng,
      cityOther: generalDetails?.cityOther,
    };
  }
  const data = {
    pcId,
    branchId,
    empId,
    isPc: pc ?? false,
    isEmp: isEmp ?? false,
    type,
    planningId,
    addressData: address,
    distance: distance ?? null
  };

  if (empId && pcId && branchId) {
    const response = await ApiCall.service(
      `${GET_PLANNING_RELOCATION_DETAILS}`,
      "POST",
      data,
      true,
      COMPANY_MICROSERVICE
    );

    if (response?.status === 200) {
      if(distance) {
      const { relocationDetails } =
        response?.data;
      if (Object.keys(relocationDetails).length > 0) {
        Object.entries(relocationDetails).forEach(([key, value]) => {
          dispatch({
            type: UPDATE_FIELDS,
            tab: REMENUARATION_DETAILS,
            field: key,
            value: value,
          });
        });
      }
      } else {
           const { relocationDetails, pcDetails, empAge, isEmpFirstContract } =
        response?.data;
      if (Object.keys(relocationDetails).length > 0) {
        Object.entries(relocationDetails).forEach(([key, value]) => {
          dispatch({
            type: UPDATE_FIELDS,
            tab: REMENUARATION_DETAILS,
            field: key,
            value: value,
          });
        });
      }

      if (Object.keys(pcDetails).length > 0) {
        const dropdownOptions = {
          pcDetails: pcDetails,
        };

        dispatch({ type: SET_DROPDOWN_DATA, payload: dropdownOptions });
      }
      // updating empAge and isEmpFirstContract value
      if(empAge){
        const data = [
          { field: "empAge", value: empAge },
          { field: "isEmpFirstContract", value: isEmpFirstContract },
        ];

        data.forEach(({ field, value }) => {
          dispatch({
            type: UPDATE_FIELDS,
            tab: BASIC_DETAILS,
            field,
            value,
          });
        });
      }
    }
    } else {
      CustomNotify({
        type: "error",
        message: t("Some error occured"),
      });
    }
  }
};
